import { useEffect } from 'react';

import { Dayjs } from 'dayjs';

import { CompanyUserPermission } from '~apis/role/type';
import { PermissionGuard } from '~components/Role/PermissionGuard';
import SettlementList from '~components/Settlement/SettlementList';
import { MIXPANEL_EVENT } from '~libs/mixpanel/event';
import { mixpanel } from '~pages/_app';

const type = 'SALES';

interface Props {
  businessEntityId?: number;
  defaultStartDate?: Dayjs;
  defaultEndDate?: Dayjs;
}

export const PAGE_NAME = 'SalesSettlement' as const;

const SalesSettlementPage: React.FC<Props> = ({
  businessEntityId,
  defaultStartDate,
  defaultEndDate,
}) => {
  useEffect(() => {
    mixpanel.track(MIXPANEL_EVENT.VIEW.CLOBE_PAGE, {
      page: PAGE_NAME,
    });
  }, []);

  return (
    <PermissionGuard
      showModal
      required={CompanyUserPermission.CAN_MANAGE_SALES_PURCHASES_SETTLEMENT}
    >
      <SettlementList
        type={type}
        businessEntityId={businessEntityId}
        defaultStartDate={defaultStartDate}
        defaultEndDate={defaultEndDate}
      />
    </PermissionGuard>
  );
};

export default SalesSettlementPage;
